import config from './url-directory';
import endpoints from './api-endpoint-url';
import _ from 'lodash';
import store from '../redux/configure-store';

export function isLocalhost () {
  return  window && window.location.hostname.toLowerCase().indexOf('localhost') !== -1;
}

export function getEnvironment() {
  if(isLocalhost ()){
    return 'LOCALHOST'
  }
  const appConfig = store.getState().appConfig;
  const { environment } = appConfig;
  return _.upperCase(environment);
}

export function getInternalOrExternalDomain() {
  const domain = window.location.hostname.toLowerCase().indexOf('.awstrp.net') !== -1 ? 'INTERNAL' : 'EXTERNAL';
  return domain;
}

export const isInternal = () => {
  return getInternalOrExternalDomain() === 'INTERNAL' ? true : false;
}

export function isAEMAuthor ()  {
  const domain = window.location.href.toLowerCase().indexOf('localhost:4502') !== -1 || window.location.hostname.toLowerCase().indexOf('author') !== -1;
  return domain;
}

export function isMobileApp () {
  const urlParams = new URLSearchParams(window.location.search);
  const isMobileApp = urlParams.get('mobile-app') === 'true';
  return isMobileApp;
}

export function isTouchDevice () {
  return (('ontouchstart' in window) ||
      (navigator.maxTouchPoints > 0) ||
      (navigator.msMaxTouchPoints > 0));
}

export function getApiKey() {
  if(isLocalhost ()){
    return ''
  }
  const appConfig = store.getState().appConfig;
  const { apiKey } = appConfig;
  return apiKey;
}
export function getApiKeyFIS() {
  if(isLocalhost ()){
    return ''
  }
  const appConfig = store.getState().appConfig;
  const { apiKeyFIS } = appConfig;
  return apiKeyFIS;
}

export function getDomain() {
  const envObject = config[getEnvironment()];
  return envObject && envObject[getInternalOrExternalDomain()]['web'];
}

export function getWebDomain() {
  const envObject = config[getEnvironment()];
  const webDomain = envObject && envObject[getInternalOrExternalDomain()]['fisweb'];
  return webDomain;
}

export function getApiDomain() {
  const envObject = config[getEnvironment()];
  const apiDomain = envObject && envObject[getInternalOrExternalDomain()]['fisapi'];
  return apiDomain;
}
export function getApiURL(uriKey) {
  const envObject = endpoints[getEnvironment()];
  return envObject && envObject[uriKey];
}

export const getOptionsObject = (api,quaryParam) => ({
  url: getApiDomain() + getApiURL(api)+ (isLocalhost ()?'':quaryParam),
  method: 'GET',
  crossDomain: true,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'x-trp-requested-with': 'XMLHttpRequest',
    'Accept': 'application/json',
    apiKey: getApiKeyFIS(),
    'beneclientchanneluserid': 'MRP',
  },
});

export const getPostOptionsObject = (api,quaryParam, data) => {
  if(data) {
    return {
      ...getOptionsObject(api,''),
      method: 'POST',
      data,
    }
  }
  return {
    ...getOptionsObject(api,quaryParam),
    method: 'POST',
  }
};

export const getPutOptionsObject = (api,quaryParam, data) => {
  if(data) {
    return {
      ...getOptionsObject(api,''),
      method: 'PUT',
      data,
    }
  }
  return {
    ...getOptionsObject(api,quaryParam),
    method: 'PUT',
  }
};

export const getDeleteOptionsObject = (api,queryParam, data) => {
  if(data) {
    return {
      ...getOptionsObject(api,''),
      method: 'DELETE',
      data,
    }
  }
  return {
    ...getOptionsObject(api,queryParam),
    method: 'DELETE',
  }
};

